import { Tag } from '@cian/components';
import * as React from 'react';

import { EPlacementType } from '../../../../json_query';
import { IPlacementTypeTag } from '../../../state/tags/definitions/placement_type';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IPlacementTypeTagItemProps {
  tag: IPlacementTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const placementTypeMap = {
  [EPlacementType.ShoppingMall]: 'В торговом комплексе',
  [EPlacementType.StreetRetail]: 'Street retail',
};

export const PlacementTypeTagItem = ({ onDeleteClick, tag, withNewTag }: IPlacementTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {placementTypeMap[tag.value]}
    </TagComponent>
  );
};
